<template>
  <div class="full-height" v-loading="isAnomaliesLoading">
    <!-- <el-row type="flex" class="account-summary__row" :gutter="20">
      <el-col :span="6">
        <div class="display-inline-block">
          <span class="display-block title">LOGIN</span>
          <span class="display-block count">{{ anomalySummary.anomalyCategoryCount.LOGIN_ANOMALY || 0 }}</span>
          <el-link @click="loadDocumentation('dashboard-assets')" :underline="false">
            <a class="display-inline-block">learn more</a>
          </el-link>
        </div>
      </el-col>
      <el-col :span="6">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block">
            <span class="display-block">NETWORK</span>
            <span class="display-block count">{{ anomalySummary.anomalyCategoryCount.NETWORK_ANOMALY || 0 }}</span>
            <el-link @click="loadDocumentation('dashboard-assets')" :underline="false">
              <a class="display-inline-block">learn more</a>
            </el-link>
          </div>
        </el-col>
        <el-col :span="6">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block">
            <span class="display-block">PROCESS</span>
            <span class="display-block count">{{ anomalySummary.anomalyCategoryCount.PROCESS_ANOMALY || 0 }}</span>
            <el-link @click="loadDocumentation('dashboard-assets')" :underline="false">
              <a class="display-inline-block">learn more</a>
            </el-link>
          </div>
        </el-col>
       <el-col :span="18">
        <div class="float-right info-buttons">
          <el-button class="help-button" size="small" style="background: white">
            <el-link @click="loadDocumentation('page-hosts')" :underline="false">
              Help/Support
            </el-link>
          </el-button>
          <el-button class="add-button" size="small" @click="loadDocumentation('page-hosts')">
            Feedback
          </el-button>
        </div>
      </el-col>
     </el-row>  -->
    <div class="table-toolbar" v-if="anomaliesReqStatus === 'saved'">
      <table-toolbar
        ref="anomalyTableToolbar"
        :key="anomalies.key"
        :search-properties="visibleColumns"
        :total-search-properties="columns"
        :search-data="anomalies"
        :initial-tags="anomalies.searchTags"
        :reload-component="anomalies.reloadToolbar"
        :active-filter-data="activeFiltersData"
        :disable-search-box="disableSearchBox"
        @refresh-tabledata="refreshTableData"
        @update-querydata="updateTableQueryData"
        @update-columns-data="modifyColumnsData"
        @add-searchtags="addSearchTags"
        @deactivate-filter="deactivateFilter"
      >
        <div slot="left-toolbar-tools" class="filter-button-group">
          <el-button
            size="small"
            round
            :class="{ active: anomalyFiltersSelected.includes('all') }"
            @click.native="changeFilterSelection('all')"
          >
            All
          </el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button
            size="small"
            round
            :class="{ active: anomalyFiltersSelected.includes('active') }"
            @click.native="changeFilterSelection('active')"
          >
            Active
          </el-button>
          <el-button
            size="small"
            round
            :class="{ active: anomalyFiltersSelected.includes('dismissed') }"
            @click.native="changeFilterSelection('dismissed')"
          >
            Dismissed
          </el-button>
          <el-divider direction="vertical"></el-divider>
          <span v-if="filterList.length">
            <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
              <el-input
                ref="customFilterInput"
                class="filter-input"
                v-if="btn.editFlag"
                placeholder="+Name"
                v-model="btn.name"
                @change.native.stop="handleFilterNameChange(btn)"
                @keyup.native.enter="handleFilterNameChange(btn)"
                @blur="handleFilterNameChange(btn)"
              ></el-input>
              <el-button
                v-else
                size="small"
                round
                :class="{'active': btn.active}"
                :id="btn.id"
                @click="changeState(btn)"
              >
                {{ btn.name}}
                <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                <span>
                  <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                  <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                </span>
                </el-tooltip>
              </el-button>

              <span v-if="btn.errFlag" class="filter-name-validator">{{filterErrMsg}}</span>
            </div>
          </span>
        </div>
        <div slot="search-actions">
          <date-range-dropdown
            :disable-selection="isAnomaliesLoading"
            :date-range-options="dateRangeOptions"
            :store-pref-constant="daterangeUserPrefConstant"
            :date-range-val="anomaliesDateRangeUserSetting"
          ></date-range-dropdown>
        </div>
      </table-toolbar>
    </div>

    <expandable-table-element
      v-if="anomaliesReqStatus === 'saved'"
      ref="anomaliesTable"
      class="anomalies-table"
      :columns="visibleColumns"
      :table-data="anomalies"
      :height-offset="40"
      @update-record-count="recordCountHandler"
    ></expandable-table-element>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { anomaliesMetaInfo } from '@/column-header/anomalies/anomalies-meta'
import { ANOMALIES_DATE_RANGE_PREFERENCE } from '@/store/modules/user_pref/user-pref.type'
import {
  ANOMALIES_LIST_REQ,
  ANOMALIES_SUMMARY_REQ,
  ANOMALIES_LIST_SUCCESS,
  ANOMALIES_VIEW_PREFERENCES_REQ,
  SAVE_ANOMALIES_VIEW_PREFERENCES
} from '@/store/modules/anomalies/anomalies.type'
import { AGENT_LIST_REQ } from '@/store/modules/agents/agents.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import customFilterMixin from '@/mixins/customFilterMixin'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import BasicTableElement from '@/components/table/BasicTableElement.vue'
import ExpandableTableElement from '@/components/table/ExpandableTableElement.vue'
import DateRangeDropdown from '@/components/dropdown/DateRangeDropdown.vue'
import { INSIGHTS_DATE_RANGE_CHOICES } from '@/constants/datetime.constants'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'

export default {
  name: 'Anomalies',
  mixins: [loadDocumentationMixin, customFilterMixin],
  components: {
    PageHeaders,
    TableToolbar,
    ActionTableElement,
    BasicTableElement,
    ExpandableTableElement,
    DateRangeDropdown
  },
  data () {
    return {
      anomaliesColumnPrefs: {},
      tableName: "Anomalies",
      breadcrumbs: [{ title: 'Detections' }],
      columns: anomaliesMetaInfo.meta.columns,
      // visibleColumns: anomaliesMetaInfo.meta.columns,
      visibleColumns: [],
      daterangeUserPrefConstant: ANOMALIES_DATE_RANGE_PREFERENCE,
      dateRangeOptions: INSIGHTS_DATE_RANGE_CHOICES,
      anomalyFiltersSelected: ['all'],
      filtersSelected: [],
      changeFilterSelection: {},
      tblId: 7
    }
  },
  created () {
    if (!this.$_.isEmpty(this.$route.query.date_range)) {
      this.$store.dispatch(this.daterangeUserPrefConstant, this.$route.query.date_range)
    }

    this.changeFilterSelection = _.debounce((field, event) => {
      this.filterTableBy(field)
    }, 250)

    this.fetchAnomalies({
      activePage: 1,
      searchTags: []
    })
    this.loadAnomaliesColumnPreferences()
  },
  methods: {
    filterTableBy (filterField) {
      switch (filterField) {
        case 'all':
          if (!this.anomalyFiltersSelected.includes('all')) {
            this.anomalyFiltersSelected.splice(0, 1, 'all')
            this.filtersSelected.length = 0
            this.anomalies.resetFilteredObjectAndSearch()
          }
          break
        case 'active':
          if (!this.anomalyFiltersSelected.includes('active')) {
            let currFilter = this.anomalyFiltersSelected[0]
            this.anomalyFiltersSelected.splice(0, 1, 'active')
            if (currFilter === 'dismissed') {
              this.anomalies.removeFilteredObjectAndSearch('state', 'INACTIVE')
            }
            this.anomalies.filterDataByProperty('state', 'ACTIVE')
          }
          break
        case 'dismissed':
          if (!this.anomalyFiltersSelected.includes('dismissed')) {
            let currFilter = this.anomalyFiltersSelected[0]
            this.anomalyFiltersSelected.splice(0, 1, 'dismissed')
            if (currFilter === 'active') {
              this.anomalies.removeFilteredObjectAndSearch('state', 'ACTIVE')
            }
            this.anomalies.filterDataByProperty('state', 'INACTIVE')
          }
          break
      }
      this.updateTableQueryData()
      if (this.$refs['anomalyTableToolbar']) {
        this.$refs['anomalyTableToolbar'].setQueryCountText()
      }
    },
    refreshTableData (tableMetaData) {
      this.fetchAnomalies(tableMetaData)
    },
    fetchAnomalies (tableMetaData) {
      if (this.agentListReqStatus !== 'saved') {
        this.$store.dispatch(AGENT_LIST_REQ).then(resp => {
          Promise.all([
            this.$store.dispatch(ANOMALIES_LIST_REQ, { dateRangeSel: this.anomaliesDateRangeUserSetting }),
            this.$store.dispatch(ANOMALIES_SUMMARY_REQ)
          ]).then(collection => {
            this.$store.dispatch(ANOMALIES_LIST_SUCCESS)
            this.setTableMetaData(tableMetaData)
          })
        })
      } else {
        Promise.all([
          this.$store.dispatch(ANOMALIES_LIST_REQ, { dateRangeSel: this.anomaliesDateRangeUserSetting }),
          this.$store.dispatch(ANOMALIES_SUMMARY_REQ, { dateRangeSel: this.anomaliesDateRangeUserSetting })
        ]).then(collection => {
          this.$store.dispatch(ANOMALIES_LIST_SUCCESS)
          this.setTableMetaData(tableMetaData)

          if (this.anomalyFiltersSelected.includes('active')) {
            this.anomalies.filterDataByProperty('state', 'ACTIVE')
          } else if (this.anomalyFiltersSelected.includes('dismissed')) {
            this.anomalies.filterDataByProperty('state', 'DISMISSED')
          }
        })
      }
    },
    updateTableQueryData () {
      if (this.$refs.anomaliesTable) {
        this.$refs.anomaliesTable.updateTableData()
      }
    },
    modifyColumnsData (selectedColumns) {
      this.anomaliesColumnPrefs.userId = this.userProfile.id;
      this.anomaliesColumnPrefs.tblName = this.tableName;
      this.anomaliesColumnPrefs.preferedCols = selectedColumns.length === 0? NaN: selectedColumns;
      this.anomaliesColumnPrefs.tblId = 7;

      this.visibleColumns = this.anomalies.updateVisibleColumns(this.columns, selectedColumns)

      this.$store.dispatch(SAVE_ANOMALIES_VIEW_PREFERENCES, this.anomaliesColumnPrefs).then(
        data => {
          // store preferences in vuex
          this.anomaliesColumnPrefs.preferedCols = this.visibleColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.anomaliesColumnPrefs);
        })
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.anomalies.key = !this.anomalies.key
      this.anomalies.reloadToolbar = false
    },
    setTableMetaData (tableMetaData) {
      this.anomalies.searchTags = tableMetaData.searchTags
      this.anomalies.currentPage = tableMetaData.activePage
    },
    loadAnomaliesColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(ANOMALIES_VIEW_PREFERENCES_REQ, this.userProfile.id)
          .then(data => {
            this.visibleColumns = this.columns.filter(col => {
              return this.anomaliesPreferences.includes(col.label)
            })
            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs () {
      this.anomaliesColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.anomaliesColumnPrefs);
    }
  },
  computed: {
    ...mapGetters([
      'userProfile',
      'anomalySummaryReqStatus',
      'anomalySummary',
      'anomaliesReqStatus',
      'anomalies',
      'agentListReqStatus',
      'anomaliesDateRangeUserSetting',
      'anomaliesPreferences',
      'userProfile',
      'userPref'
    ]),
    isAnomaliesLoading () {
      return this.anomaliesReqStatus === '' || this.anomaliesReqStatus === 'loading'
    }
  },
  watch: {
    anomaliesDateRangeUserSetting: {
      handler: function (newDateRange, oldDateRange) {
        if (newDateRange !== oldDateRange) {
          this.refreshTableData({
            activePage: 1,
            searchTags: this.anomalies.searchTags
          })
        }
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/global_classes.css';
@import 'assets/styles/icon.css';
@import 'assets/styles/accounts_list.css';

.el-button {
  background-color: var(--aluminum-800);
  color: white;
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  left: 5%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/anomalies/Anomalies.vue